if(!window.__pl_cole){window.__pl_cole=1;

(function(){
  var d=document;
  var cards=d.querySelectorAll('#grid .cc'),out=d.getElementById('picked'),N={todo:'Los 2 cursos',vender:'Parte por: Haz que venda',anuncios:'Parte por: Meta Ads: De cero a 100'};
  d.querySelectorAll('.chip').forEach(function(b){b.addEventListener('click',function(){
    var f=b.dataset.f;d.querySelectorAll('.chip').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
    cards.forEach(function(c){var on=f==='todo'||f==='all'||(','+(c.dataset.t||c.dataset.c||'').replace(/ /g,',')+',').indexOf(','+f+',')>-1;c.hidden=!on;if(on)c.classList.add('in')});
    if(out)out.textContent=b.dataset.p||N[f]||'';
  })});
  if(!('IntersectionObserver' in window))return;
  d.documentElement.classList.add('js');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
  d.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
  var s=d.getElementById('sticky'),hero=d.querySelector('.hero'),closing=d.querySelector('.closing'),hv=true,cv=false;
  if(!s||!hero||!closing)return;
  function u(){s.classList.toggle('on',!hv&&!cv)}
  new IntersectionObserver(function(e){hv=e[0].isIntersecting;u()}).observe(hero);
  new IntersectionObserver(function(e){cv=e[0].isIntersecting;u()}).observe(closing);
})();

document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('.rv').forEach(function(x){x.classList.add('in')})});if(window.Shopify&&Shopify.designMode){document.documentElement.classList.add('pl-editor')}
}